import * as React from 'react';

import {IContentBlock} from 'features/blocks/types';

import 'components/blocks/Corporate/CorporatePageListItemBlock/style.scss';

import {ArticleTeaser} from '@molecules/ContentLinkCard/ArticleTeaser';
import {EpiImage} from "features/search/types";

export interface CorporatePageListItemBlockType {
    title: string;
    text: string;
    linkUrl: string;
    linkText: string;
    image?: EpiImage;
}

type Props = IContentBlock<CorporatePageListItemBlockType>;

export const CorporatePageListItemBlock: React.FunctionComponent<Props> = (props) => {
    return (
        <ArticleTeaser
            linkUrl={props.data.linkUrl}
            linkText={props.data.linkText}
            image={props.data.image}
            title={props.data.title}
            text={props.data.text}
            className="corporate-page-list-item-block"
            id={props.id}
        />
    )
};

